(function () {

    function initImproveSection() {

        const VISIBLE_DESKTOP = 4;

        function isMobile() {
            return window.innerWidth <= 768;
        }

        document.querySelectorAll(".improve-section .cat-panel").forEach((panel) => {

            // Prevent duplicate initialization
            if (panel.dataset.initialized === "true") return;
            panel.dataset.initialized = "true";

            const track = panel.querySelector(".products-track");
            const prevBtn = panel.querySelector(".prev-btn");
            const nextBtn = panel.querySelector(".next-btn");
            const viewport = panel.querySelector(".products-viewport");
            const dots = panel.querySelectorAll(".dots span");

            if (!track || !prevBtn || !nextBtn || !viewport) return;

            const cards = [...track.children];

            let desktopIndex = 0;
            let mobileIndex = 0;

            function updateDesktop() {

                const visible = VISIBLE_DESKTOP;
                const maxStart = Math.max(0, cards.length - visible);

                desktopIndex = Math.max(0, Math.min(desktopIndex, maxStart));

                const cardWidth = cards[0].offsetWidth;
                const gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 18);

                track.style.transition = "transform .35s ease";
                track.style.transform =
                    `translateX(-${desktopIndex * (cardWidth + gap)}px)`;

                prevBtn.disabled = desktopIndex <= 0;
                nextBtn.disabled = desktopIndex >= maxStart;
            }

            function updateMobile() {

                const width = viewport.offsetWidth;

                track.style.transition = "transform .35s ease";
                track.style.transform =
                    `translateX(-${mobileIndex * width}px)`;

                dots.forEach((dot, i) => {
                    dot.classList.toggle("active", i === mobileIndex);
                });

                prevBtn.disabled = false;
                nextBtn.disabled = false;
            }

            function update() {
                if (isMobile()) {
                    updateMobile();
                } else {
                    updateDesktop();
                }
            }

            prevBtn.addEventListener("click", function () {

                if (isMobile()) {
                    mobileIndex =
                        (mobileIndex - 1 + cards.length) % cards.length;
                } else {
                    desktopIndex--;
                }

                update();

            });

            nextBtn.addEventListener("click", function () {

                if (isMobile()) {
                    mobileIndex =
                        (mobileIndex + 1) % cards.length;
                } else {
                    desktopIndex++;
                }

                update();

            });

            // Touch Swipe

            let startX = 0;

            viewport.addEventListener("touchstart", function (e) {
                startX = e.touches[0].clientX;
            }, { passive: true });

            viewport.addEventListener("touchend", function (e) {

                const endX = e.changedTouches[0].clientX;
                const diff = endX - startX;

                if (!isMobile()) return;

                if (Math.abs(diff) > 50) {

                    if (diff > 0) {
                        prevBtn.click();
                    } else {
                        nextBtn.click();
                    }

                }

            }, { passive: true });

            panel._recalc = update;

            update();

        });

        // Category Tabs

        document.querySelectorAll(".improve-section .cat-btn").forEach((btn) => {

            if (btn.dataset.initialized === "true") return;
            btn.dataset.initialized = "true";

            btn.addEventListener("click", function () {

                const key = this.dataset.cat;

                document.querySelectorAll(".improve-section .cat-btn").forEach((b) => {

                    const active = b === this;

                    b.classList.toggle("active", active);
                    b.setAttribute("aria-selected", active);

                }, this);

                document.querySelectorAll(".improve-section .cat-panel").forEach((panel) => {

                    const active = panel.dataset.cat === key;

                    panel.hidden = !active;

                    if (active) {

                        requestAnimationFrame(() => {

                            if (panel._recalc) {
                                panel._recalc();
                            }

                        });

                    }

                });

            });

        });

    }

    document.addEventListener("DOMContentLoaded", initImproveSection);

    document.addEventListener("shopify:section:load", initImproveSection);

})();